import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import createField from '../../../utils/factory/createField'

export const brandFields = [
  {
    section: 'Dados da Marca',
    fields: [
      createField({
        id: 'brand.name',
        label: 'Marca',
        type: 'text',
        placeholder: 'Digite o nome da marca',
        fullWidth: true,
        icon: faCheckCircle,
      }),
    ],
  },
]
